import { create } from 'zustand'

const initialState = {
  error: null,
  showError: false
}
export const useErrorStore = create((set) => ({
  ...initialState,
  setError: (error) => set({ error, showError: true }),
  setInfo: (info) => set({ info }),
  clearError: () => set({ error: null, info: null, showError: false }),
  logout: () => set(initialState)
}))
